<template>
  <!-- <div>
    <h2>My Sessions</h2>
    <p>This is the My Sessions page.</p>
  </div> -->
  <Layout>
    <div class="container body-content">
      <h2>My Sessions</h2>
      <p>This is the My Sessions page.</p>
    </div>
  </Layout>
</template> 
<script>
  import Layout from '@/components/Layout.vue'
  export default {
    name: 'MySessions',
    components: {
      Layout
    }
  }
</script>